import React from 'react'
import { connect } from 'react-redux'
import VoucherForm from './VoucherForm'

import {
  clear_voucher,
} from '../actions'

const mapStateToProps = state => {
  return {

  }
}
const mapDispatchToProps = dispatch => {
  return {
    clearVoucher: () => dispatch( clear_voucher() ),
  }
}

class ConnectedVoucherNew extends React.Component {
  componentWillMount() {
    this.props.clearVoucher()
  }

  render(){
    return <VoucherForm actionName="create"/>
  }
}

const VoucherNew = connect(mapStateToProps, mapDispatchToProps)(ConnectedVoucherNew)
export default VoucherNew



// WEBPACK FOOTER //
// ./src/js/components/VoucherNew.js